<template>
    <div class="text-block block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_audio_round.png" alt="">
                        </div>

                        <h4>Audio</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <p>Allows to send an audio file in the chat. Supported formats: MP3, WAV, OGG. Maximum file size: ~20MB. If you use Dropbox, please replace "www" at the beginning of the audio file URL with "dl".
                        Example: https://dl.dropbox.com/s/sample.mp3</p>
                    <label >Audio File URL</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.url"-->
<!--                            :error="!data.url || !common.validURL(data.url)"-->
<!--                            :error-messages="!data.url? 'URL is Required':'' || !common.validURL(data.url)? 'URL is not valid':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.url" :type="'textfield'"
                                           :validationRules="autocompleteAudioValidationRules"></vTextareaAutocomplete>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    export default {
        name: "card-audio",
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common,
                autocompleteAudioValidationRules: [
                    v => !!v || 'Url is Required'
                ]
            }
        },
        mounted() {

        },
        methods: {

        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>